export default __webpack_public_path__ + "static/media/clear_sky.1fd34a65.png";